module.exports = __webpack_public_path__ + "img/ppt.a6bb914.svg";